import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'common-progress-spinner',
	templateUrl: './progress-spinner.component.html',
	styleUrls: ['./progress-spinner.component.scss'],
	standalone: false
})
export class ProgressSpinnerComponent implements OnInit {
	@Input() diameter: string;
	@Input() strokeColor: string;
	@Input() strokeWidth: string;

	ngOnInit() {
		this.diameter = `${ (parseFloat(this.diameter) / 10) }rem`;
		this.strokeWidth = `${ (parseFloat(this.strokeWidth) / 10) }rem`;
	}
}
